module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/3_4.e9dfb01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/3_4.jpg
// module id = jRQi
// module chunks = 0